module.exports = __webpack_public_path__ + "assets/img/TextTranslation-banner.bdd49e34.png";